/* Patchstore24 – Anfrageformular (ersetzt Powerful Form Builder)
 * 1) Setzt das Formular an die Stellen, an denen bisher das Globo-Formular saß (bis die Sektion im Theme-Editor eingefügt ist).
 * 2) Beim Absenden: optional an Zapier (Webhook, inkl. Datei) -> dann normales Shopify-Kontaktformular (Mail an die Shop-Adresse).
 */
(function () {
  'use strict';
  // >>> Hier die Zapier-Adresse eintragen ("Webhooks by Zapier" -> "Catch Hook"). Leer = nur Shopify-Mail.
  var ZAPIER_HOOK = 'https://hooks.zapier.com/hooks/catch/14667829/32djk5s/'; // DE-Zap "Anfrage - Zendesk"
  // Zusätzlich die Shopify-Kontaktmail senden? (true = Backup per Mail; false, falls euer Zap auf Mails reagiert -> sonst doppelte Tickets)
  var ALSO_EMAIL = false; // Zap legt das Zendesk-Ticket an

  var TYPE_BY_HANDLE = { 'gestickte-patches': 'Gestickt', 'gedruckte-patches': 'Gedruckt', 'gewebte-patches': 'Gewebt', 'chenille-patches': 'Chenille', 'pailletten-patches': 'Pailletten', '2d-rubber-patches': '2D Rubber (PVC)', '3d-rubber-patches': '3D Rubber (PVC)', 'emaille-pin': 'Emaille-Pin' };

  function wire(root) {
    var form = root.querySelector('form');
    if (!form || form.dataset.psWired) return;
    form.dataset.psWired = '1';
    // Dunkler Hintergrund? -> helle Beschriftungen
    for (var el = root; el && el !== document.documentElement; el = el.parentElement) {
      var bg = getComputedStyle(el).backgroundColor, m2 = bg.match(/rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?/);
      if (m2 && (m2[4] === undefined || +m2[4] > 0.5)) { if ((+m2[1] * 299 + +m2[2] * 587 + +m2[3] * 114) / 1000 < 128) root.classList.add('ps-inq--dark'); break; }
    }
    var page = form.querySelector('[data-ps-page]'); if (page) page.value = location.origin + location.pathname;
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    var sel = form.querySelector('select[name="contact[Patch type]"]');
    if (m && sel && TYPE_BY_HANDLE[m[1]]) sel.value = TYPE_BY_HANDLE[m[1]];
    var fileBox = form.querySelector('[data-ps-file]'), fileNote = form.querySelector('[data-ps-file-note]');
    if (ZAPIER_HOOK) { if (fileBox) fileBox.hidden = false; if (fileNote) fileNote.hidden = true; }
    var fileIn = form.querySelector('[data-ps-file-input]'), fileName = form.querySelector('[data-ps-file-name]');
    if (fileIn && fileName) fileIn.addEventListener('change', function () { fileName.textContent = fileIn.files && fileIn.files[0] ? fileIn.files[0].name : 'Keine Datei ausgewählt'; });
    if (/[?&]contact_posted=true/.test(location.search) && !form.querySelector('.ps-inq__ok')) {
      form.insertAdjacentHTML('afterbegin', '<div class="ps-inq__ok" role="status">Danke! Ihre Anfrage ist bei uns. Wir melden uns innerhalb eines Werktags.</div>');
    }
    var msg = form.querySelector('[data-ps-msg]');
    // Capture-Phase auf window: läuft vor Shopifys CAPTCHA-Skript. Erster Durchlauf = unsere Prüfung + Zapier,
    // zweiter Durchlauf (requestSubmit) läuft normal durch, damit Shopify das CAPTCHA-Token anhängen kann.
    window.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (form.dataset.psSending === 'native') return; // zweiter Durchlauf: Shopify (inkl. CAPTCHA) übernimmt
      e.preventDefault(); e.stopImmediatePropagation();
      var hp = form.querySelector('input[name="contact[website]"]');
      if (hp && hp.value) return; // Spam-Bot
      var bad = Array.prototype.filter.call(form.querySelectorAll('[required]'), function (i) { return !i.value.trim() || (i.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(i.value)); });
      if (bad.length) { msg.textContent = 'Bitte ausfüllen: ' + bad.map(function (i) { return i.parentNode.firstChild.textContent.replace('*', '').trim(); }).join(', '); msg.hidden = false; bad[0].focus(); return; }
      var file = form.querySelector('[data-ps-file-input]'); file = file && file.files && file.files[0];
      if (file && file.size > 20 * 1024 * 1024) { msg.textContent = 'Die Datei ist zu groß (max. 20 MB).'; msg.hidden = false; return; }
      msg.hidden = true;
      var btn = form.querySelector('button[type=submit]'); if (btn) { btn.disabled = true; btn.textContent = 'Wird gesendet …'; }
      var send = Promise.resolve();
      if (ZAPIER_HOOK) {
        var fd = new FormData();
        // Feldnamen wie im bestehenden Zap (Form Builder): Name, Email, Width, Height, Quantity, Message, File, Page_Href ...
        var KEYS = { name: 'Name', email: 'Email', body: 'Message', 'Patch type': 'Patch_Type', Page: 'Page_Href' };
        Array.prototype.forEach.call(form.querySelectorAll('[name^="contact["]'), function (i) { var k = i.name.slice(8, -1); if (k !== 'website' && i.value) fd.append(KEYS[k] || k, i.value); });
        if (file) { fd.append('File', file, file.name); fd.append('File_Name', file.name); }
        fd.append('Page_Title', document.title);
        fd.append('Date_Created', new Date().toISOString());
        send = Promise.race([
          fetch(ZAPIER_HOOK, { method: 'POST', body: fd, mode: 'no-cors' }),
          new Promise(function (r) { setTimeout(r, 8000); })
        ]).catch(function () {});
      }
      send.then(function () {
        if (ALSO_EMAIL || !ZAPIER_HOOK) {
          form.dataset.psSending = 'native';
          if (btn) btn.disabled = false;
          if (form.requestSubmit) form.requestSubmit(btn || undefined); else if (btn) btn.click(); else HTMLFormElement.prototype.submit.call(form);
        }
        else { form.innerHTML = '<div class="ps-inq__ok" role="status">Danke! Ihre Anfrage ist bei uns. Wir melden uns innerhalb eines Werktags.</div>'; }
      });
    }, true);
  }

  function mount() {
    // Platzhalter der alten Formular-App (Globo Form Builder, Formular 152709)
    var spots = document.querySelectorAll('.globo-formbuilder[data-id="MTUyNzA5"]');
    var own = document.querySelectorAll('[data-ps-inquiry]');
    own.forEach(wire);
    if (!spots.length) return;
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + '?section_id=ps-inquiry' : '/?section_id=ps-inquiry')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        spots.forEach(function (spot) {
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          var inq = wrap.querySelector('[data-ps-inquiry]');
          if (!inq) return;
          var h = inq.querySelector('.ps-inq__h');
          // Wenn die Seite selbst schon eine Überschrift über dem Formular hat, keine zweite zeigen
          var sec = spot.closest('[id^="shopify-section"]');
          if (h && sec && sec.querySelector('h1,h2')) h.remove();
          spot.replaceWith(inq);
          wire(inq);
        });
      });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();
